module.exports = __webpack_public_path__ + "static/media/2.bdb4e7ff.png";